<!--
	@name app-source-quick-source
	@description Sourcing Page
	@date 2020/02/27
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<p class="text-h6 font-weight-bold mb-2">
			Quick Source has been retired
		</p>

		<p class="text-body-1 mb-10">
			If you're looking for an indicative view of a client's borrowing potential to support early client conversations,
			<span class="font-weight-bold">
				<router-link to="/tools/max-ltv-tool">
					click here
				</router-link>
				to use our innovative Max LTV tool</span>. For more accurate, case-specific results,
			<span class="font-weight-bold">
				<a class="font-weight-bold" @click="$emit('switch-to-full-source')">click here</a>
				to complete a sourcing session via Source a Product</span>, providing a comprehensive view of the products, features and rates that could meet your client's needs.
		</p>

		<h2 class="text-body-1 font-weight-bold mb-2">
			Why has Quick Source been retired?
		</h2>

		<p class="text-body-2 mb-3">
			With more lenders using property-specific pricing and detailed eligibility criteria, sourcing accuracy is more important than ever. As a result, Quick Source has
			been retired.
			Quick Source provided an indicative view using limited client and property information. Although it offered a convenient starting point, the information available
			was often insufficient to reflect the full range of lender criteria, product features and pricing now used across the market.
		</p>

		<p class="text-body-2 mb-0">
			To ensure advisers have access to the most relevant and accurate information, we recommend using Max LTV for an initial indication of borrowing potential and
			Source a Product for detailed, tailored sourcing results.
		</p>
	</div>
</template>

<script>
	export default {
		name: 'app-source-quick-source'
	};
</script>
